export const FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_REQUEST = 'FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_REQUEST'
export const FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_SUCCESS = 'FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_SUCCESS'
export const FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_FAILURE = 'FETCH_TEMPLATE_AUTO_TASK_BASED_ON_AUTO_TASK_ID_FAILURE'
